import axios from 'axios';
import { useLocation } from 'react-router';
import { STORAGE, URLS } from '../../_config';
const querystring = require('query-string');
export class CallApi {
  static GET(url, params, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = localStorage.getItem(STORAGE);
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      return axios({
        method: 'GET',
        url,
        headers,
        params,
      }).then(success => {
        return resolve(success);
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let foo = params.get('query');
        console.log(foo)
      }).catch(error => {
        if (error.response && error.response.status === 401 && window.location.pathname != URLS.USER.LOGIN) {
          localStorage.removeItem(STORAGE);
          const prevLocation = window.location.href;
          window.location.href = URLS.USER.LOGIN+`?redirectTo=${prevLocation}`;
        }
        return reject(error.response);
      });
    });
  }

  static POST(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = localStorage.getItem(STORAGE);
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      return axios({
        method: 'POST',
        url,
        headers,
        data,
      })
        .then(success => {
          return resolve(success);
        })
        .catch(error => {
          if (error.response && error.response.status === 401 && window.location.pathname != URLS.USER.LOGIN) {
            localStorage.removeItem(STORAGE);
            const prevLocation = window.location.href;
          window.location.href = URLS.USER.LOGIN+`?redirectTo=${prevLocation}`;
          }
          return reject(error.response);
        });
    });
  }

  static PUT(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = localStorage.getItem(STORAGE);
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      return axios({
        method: 'PUT',
        url,
        headers,
        data,
      })
        .then(success => {
          return resolve(success);
        })
        .catch(error => {
          if (error.response && error.response.status === 401 && window.location.pathname != URLS.USER.LOGIN) {
            localStorage.removeItem(STORAGE);
            const prevLocation = useLocation();
          window.location.href = URLS.USER.LOGIN+`?redirectTo=${prevLocation}`;
          }
          return reject(error.response);
        });
    });
  }

  static DELETE(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = localStorage.getItem(STORAGE);
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      return axios({
        method: 'DELETE',
        url,
        headers,
        data,
      })
        .then(success => {
          return resolve(success);
        })
        .catch(error => {
          if (error.response && error.response.status === 401 && window.location.pathname != URLS.USER.LOGIN) {
            localStorage.removeItem(STORAGE);
            const prevLocation = useLocation();
          window.location.href = URLS.USER.LOGIN+`?redirectTo=${prevLocation}`;
          }
          return reject(error.response);
        });
    });
  }
}
